module.exports = __webpack_public_path__ + "e6d097ad57b4d916157fd2ffa820fe30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/news/guide_869x278.jpg
// module id = 870
// module chunks = 0